module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.content.title,
      "visible": _vm.visible,
      "close-on-click-modal": false,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-position": "top",
      "label-width": "150px",
      "model": _vm.form
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Coordonnées"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": "Nom"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Nom de l'entreprise"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Adresse postale"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Numéro et nom la rue"
    },
    model: {
      value: (_vm.form.address_street),
      callback: function($$v) {
        _vm.$set(_vm.form, "address_street", $$v)
      },
      expression: "form.address_street"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Code postal"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Code postal"
    },
    model: {
      value: (_vm.form.address_zip_code),
      callback: function($$v) {
        _vm.$set(_vm.form, "address_zip_code", $$v)
      },
      expression: "form.address_zip_code"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Ville"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Ville"
    },
    model: {
      value: (_vm.form.address_city),
      callback: function($$v) {
        _vm.$set(_vm.form, "address_city", $$v)
      },
      expression: "form.address_city"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Coordonnées publiques"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": "Nom"
    }
  }, [_c('el-input', {
    attrs: {
      "required": "",
      "placeholder": _vm.form.name
    },
    model: {
      value: (_vm.form.public_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "public_name", $$v)
      },
      expression: "form.public_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Adresse postale"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.form.address_street
    },
    model: {
      value: (_vm.form.public_address_street),
      callback: function($$v) {
        _vm.$set(_vm.form, "public_address_street", $$v)
      },
      expression: "form.public_address_street"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Code postal"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.form.address_zip_code
    },
    model: {
      value: (_vm.form.public_address_zip_code),
      callback: function($$v) {
        _vm.$set(_vm.form, "public_address_zip_code", $$v)
      },
      expression: "form.public_address_zip_code"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Ville"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.form.address_city
    },
    model: {
      value: (_vm.form.public_address_city),
      callback: function($$v) {
        _vm.$set(_vm.form, "public_address_city", $$v)
      },
      expression: "form.public_address_city"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Détails et activité"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "type",
      "label": "Type"
    }
  }, [_c('el-select', {
    staticClass: "form-control",
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Client",
      "value": "CLIENT"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Ancien client",
      "value": "FORMER_CLIENT"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Prospect",
      "value": "PROSPECT"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Grande agence",
      "value": "BIG_AGENCY"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Liste noire",
      "value": "BLACKLIST"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "user_id",
      "label": "Commercial associé"
    }
  }, [_c('user-select', {
    attrs: {
      "id": _vm.form.user_id
    },
    on: {
      "change": _vm.onUserChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "job",
      "label": "Type de métier"
    }
  }, [_c('el-select', {
    staticClass: "form-control",
    model: {
      value: (_vm.form.job_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "job_type", $$v)
      },
      expression: "form.job_type"
    }
  }, _vm._l((_vm.jobs.map(function (item) { return item.type; })), function(jobType) {
    return _c('el-option', {
      key: jobType,
      attrs: {
        "value": jobType
      }
    }, [_vm._v(_vm._s(jobType))])
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "job",
      "label": "Métier"
    }
  }, [_c('el-select', {
    staticClass: "form-control",
    model: {
      value: (_vm.form.job),
      callback: function($$v) {
        _vm.$set(_vm.form, "job", $$v)
      },
      expression: "form.job"
    }
  }, _vm._l((_vm.subJobs), function(job) {
    return _c('el-option', {
      key: job,
      attrs: {
        "value": job
      }
    }, [_vm._v(_vm._s(job))])
  }), 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "m-t-2",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Informations de contact"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "first_phone",
      "label": "Téléphone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Téléphone principal"
    },
    model: {
      value: (_vm.form.first_phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "first_phone", $$v)
      },
      expression: "form.first_phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "second_phone",
      "label": "Téléphone secondaire"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Téléphone secondaire"
    },
    model: {
      value: (_vm.form.second_phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "second_phone", $$v)
      },
      expression: "form.second_phone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "email",
      "label": "Email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email de la société"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "website",
      "label": "Site internet"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Site internet de la société"
    },
    model: {
      value: (_vm.form.website),
      callback: function($$v) {
        _vm.$set(_vm.form, "website", $$v)
      },
      expression: "form.website"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "remarks",
      "label": "Infos importantes"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": "",
      "placeholder": "Mettre les infos importantes détectées dans la préparation de l'appel: types de construction, régions couvertes par la prospect, etc… "
    },
    model: {
      value: (_vm.form.remarks),
      callback: function($$v) {
        _vm.$set(_vm.form, "remarks", $$v)
      },
      expression: "form.remarks"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Liaisons"
    }
  }, [_c('p', {
    staticClass: "text-danger"
  }, [_vm._v("Quelques notes importantes sur la suppression d'une liaison :")]), _vm._v(" "), _c('ul', {
    staticClass: "text-danger"
  }, [_c('li', [_vm._v("\n                La suppression d'une liaison aura pour effet de "), _c('strong', [_vm._v("supprimer la fiche liée")]), _vm._v(". Elle sera\n                re-créé dans l'interface lors de la prochaine synchronisation de l'application (toute les nuits).\n              ")]), _vm._v(" "), _c('li', [_vm._v("\n                Afin de ne pas perdre d'éléments, les documents, services, rappels, commentaires de la fiche déliée\n                seront conservés sur cette fiche. "), _c('strong', [_vm._v("(Préférez délier des fiches vides pour ne pas garder des données\n                inutiles sur vos fiches)")])])]), _vm._v(" "), _c('el-row', {
    staticClass: "m-t-1",
    attrs: {
      "gutter": 20
    }
  }, _vm._l((_vm.sources), function(source) {
    return _c('div', {
      key: source.id
    }, [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('source-app', {
      attrs: {
        "name": source.id
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-switch', {
      attrs: {
        "disabled": !_vm.sourceStatus[source.id],
        "on-text": "",
        "off-text": ""
      },
      on: {
        "change": function($event) {
          return _vm.onSourceChange(source.id)
        }
      },
      model: {
        value: (_vm.sourceStatus[source.id]),
        callback: function($$v) {
          _vm.$set(_vm.sourceStatus, source.id, $$v)
        },
        expression: "sourceStatus[source.id]"
      }
    })], 1)], 1)
  }), 0)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.content.button_type,
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.submit(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.button))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0512f10c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Modals/CustomerModal.vue
// module id = 658
// module chunks = 1